import intro1 from "../assets/Video/intro.mp4";
import intro2 from "../assets/Video/intro2.mp4";
import intro3 from "../assets/Video/intro3.mp4";
import intro4 from "../assets/Video/intro4.mp4";

export const shortsData = [
  {
    id: 1,
    src: intro1,
    title: "Dubai Market Insights",
  },
  {
    id: 2,
    src: intro2,
    title: "Team at Work",
  },
  {
    id: 3,
    src: intro3,
    title: "Luxury Property Highlight",
  },
  {
    id: 4,
    src: intro4,
    title: "Behind the Scenes",
  },

  // 🔥 DUPLICATES WITH DIFFERENT CONTEXT (FOR NOW)
  {
    id: 5,
    src: intro1,
    title: "Investor Perspective",
  },
  {
    id: 6,
    src: intro2,
    title: "Client Walkthrough",
  },
  {
    id: 7,
    src: intro3,
    title: "Waterfront Living",
  },
  {
    id: 8,
    src: intro4,
    title: "Site Visit Moments",
  },

  {
    id: 9,
    src: intro1,
    title: "Off-Plan Opportunities",
  },
  {
    id: 10,
    src: intro2,
    title: "Vision X Nexus Culture",
  },
  {
    id: 11,
    src: intro3,
    title: "Architecture & Design",
  },
  {
    id: 12,
    src: intro4,
    title: "Day with Our Advisors",
  },
];


export const shortsDataYT = [
  {
    id: 1,
    youtubeId: "mfpfwBKf3d0",
    title: "Dubai Market Insights",
  },
  {
    id: 2,
    youtubeId: "Yelvqc1ivYU",
    title: "Team at Work",
  },
  {
    id: 3,
    youtubeId: "5uGsFTWApFE",
    title: "Luxury Property Highlight",
  },
  {
    id: 4,
    youtubeId: "8myOuWyFwSU",
    title: "Behind the Scenes",
  },
  {
    id: 5,
    youtubeId: "lmPpnTzshNM",
    title: "Investor Perspective",
  },
  {
    id: 6,
    youtubeId: "VIk-DhTl0i4",
    title: "Client Walkthrough",
  },
  {
    id: 7,
    youtubeId: "91rrBVPCg70",
    title: "Waterfront Living",
  },
  {
    id: 8,
    youtubeId: "0T76yWDcJYs",
    title: "Site Visit Moments",
  },
  {
    id: 9,
    youtubeId: "7lRmCXTQYKY",
    title: "Off-Plan Opportunities",
  },
  {
    id: 10,
    youtubeId: "KggrO9yAFus",
    title: "Vision X Nexus Culture",
  },
  {
    id: 11,
    youtubeId: "nTnmZ8tagzg",
    title: "Architecture & Design",
  },
];
